import React from 'react';
import { Box } from '@mui/material';
import CustomUserChip from '../../components/CustomUserChip';
import CustomGenericTittleIcon from "../../components/CustomGenericTittleIconDataChip";
import {userDataTransform} from "../../Apis/functions";
import {InfoChip} from "../../components/buttons/IconButtons";


const RenderExpandedRow = ({ levels, t }) => {
    return (
        <Box>
            <div className={"row"}>
                <div className={"col-12"}><CustomGenericTittleIcon Icon={undefined} title={t('approval_levels')}/></div>
                {levels.map((level, index) => (
                    <div key={level.id} className='row mt-3'>
                        {/* Level title */}
                        <div className={"col-sm-12 col-md-2 col-xxl-2 col-lg-2 pl-0"}>
                            {t('level')} {level.levelNumber}
                        </div>

                        <div className={"col-sm-12 col-md-10 col-xxl-10 col-lg-10"}>
                            <div className={"col-12 p-0 mb-3"}>
                                <CustomUserChip
                                    className={"mt-0 chip-secondary-100"}
                                    key={level.approvalCondition}
                                    name={t(level.approvalCondition.toLowerCase())}
                                    Icon={InfoChip}
                                    showAvatar={true}
                                    classNameIcon={"icon-color-secondary-700"}
                                />
                            </div>
                            <div className={"col-12 p-0 d-flex flex-wrap"}>
                                {level.approvers.map((row) => {
                                    return (
                                        <CustomUserChip
                                            className={"mt-0"}
                                            key={row.user.id}
                                            name={userDataTransform(row.user)}
                                            showAvatar
                                        />
                                    );
                                })}
                            </div>
                        </div>
                        <div className={"border-bottom-shades-300 mt-3"}/>
                    </div>
                ))}
            </div>
        </Box>
    );
};

export default RenderExpandedRow;
